import { AppLoading } from 'common/components/appLoading/appLoading';
import { loadList, showCategoryPopup } from 'features/IntegrationsSlice';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IntegrationsList } from './config';
import { Integration } from './Integration/Integration';
import { NotFound } from 'notFound/NotFound';
import { useHistory } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Common } from 'common/services/common.service';
import Fade from '@mui/material/Fade';

import './Integrations.scss';
// import { ManageNotData } from 'common/components/manageNotData/ManageNotData';

export function Integrations(props: any) {
  const dispatch = useDispatch<any>();
  const [noPermission, setNoPermission] = useState<boolean>(false);
  const { list, loading } = useSelector((state: any) => state.integrations);

  const flags = useFlags();
  const history = useHistory();

  useEffect(() => {
    const func = async () => {
      try {
        await dispatch(loadList()).unwrap();
        const category = Common.getParamFromUrl('openCategory');

        if (category?.length) {
          dispatch(showCategoryPopup(category));
        }
      } catch (err) {
        const _err: any = err;
        switch (_err.status) {
          case 403:
            setNoPermission(true);
            break;
          case 401:
            history.replace('/');
            break;
        }
      }
    };
    func();
  }, [dispatch, history]);

  const renderIntegrationsCategories = (): any => {
    let _html: any = [];
    Object.keys(IntegrationsList).forEach((category: string, i: number) => {
      if (Object.keys(IntegrationsList[category])) {
        if ((flags.isServicenowAndCortexPov && category === 'SOAR') || category !== 'SOAR') {
          _html.push(<h2 key={i}>{category}</h2>);
          _html.push(
            <ul key={category} className="integrations-list">
              {renderIntegrationsBoxes(category)}
            </ul>
          );
        }
      }
    });
    return _html;
  };

  const renderIntegrationsBoxes = (category: string) => {
    let _html: any = [];
    Object.keys(IntegrationsList[category]).forEach((app: string) => {
      const integration = list?.results?.filter((_app: any) => _app.type === app)[0];
      if (
        !IntegrationsList[category][app].is_unavailable ||
        (flags.isServicenowAndCortexPov && IntegrationsList[category][app].is_unavailable)
      ) {
        _html.push(
          <Integration
            data={IntegrationsList[category][app]}
            icon={`icon-${app}`}
            id={integration?.id}
            isActive={integration?.is_active}
            isExists={!!integration}
            key={IntegrationsList[category][app].label}
            showToggle={IntegrationsList[category][app].showToggle}
          />
        );
      }
    });
    return _html;
  };

  if (noPermission) {
    return (
      <div className="Integrations">
        <NotFound type="403" />
      </div>
    );
  }

  return (
    <div className="Integrations">
      {loading && <AppLoading />}
      {!loading && (
        <Fade in timeout={800}>
          <div>{renderIntegrationsCategories()}</div>
        </Fade>
      )}
      {/* {!list?.results?.length && <ManageNotData />} */}
    </div>
  );
}
